import React, { createContext, useState, useContext, useEffect } from "react";
import { translations } from "./translations";

// Create context
const LangContext = createContext();

// Hook for easy usage
export const useLang = () => useContext(LangContext);

// Provider
export const LangProvider = ({ children }) => {
  // ✅ Load from localStorage or default to English
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  // ✅ Save to localStorage whenever lang changes
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  // ✅ toggle helper
  const toggleLang = () => {
    setLang((prev) => (prev === "en" ? "ar" : "en"));
  };

  // ✅ translator function
  const t = (key) => translations[lang]?.[key] || key;

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LangContext.Provider>
  );
};
